module.exports = __webpack_public_path__ + "static/img/material_5_1.5cd7f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/papermaterial/material_5_1.jpg
// module id = 06dW
// module chunks = 1